import React from 'react'

export const FormattedText = ({ text }: { text: string }) => (
  <>
    {text
      .split(/(\*\*[^*]+\*\*)/g)
      .map((part, index) =>
        part.startsWith('**') && part.endsWith('**') ? (
          <strong key={index}>{part.slice(2, -2)}</strong>
        ) : (
          part
        ),
      )}
  </>
)
